import AUTH from './cookie'

export const getToken = () => {
  return AUTH.getUserCookie('access_token')
}

export const setToken = () => {
  // AUTH.setCookie('UserAccount', 'access_token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTAwMDIsImlhdCI6MTU2MDEyOTUwNn0._YoRfETrtfzsrOc3RmivE6cyTotYs89OFsupHkoLk9U&expires_in=86400&nickname=asdasd&avatar=http%3a%2f%2feditor.vgoyun.cn%2fupload%2fzaigou%2fcompany%2flogo%2f10002%2f20190528%2f9321e3a826da49a2887ca453cde5d426.png&id=10002&isads=2&isadz=2&istour=2&packageid=108&overtdt=2038-03-20&packagename=%e5%95%86%e4%b8%9a%e9%ab%98%e7%ba%a7%e4%bc%9a%e5%91%98', 2 * 60)
}
